module.exports = __webpack_public_path__ + "static/media/shelley.c539fe66.png";